import DynamicHeight from "./DynamicHeight.js";

new DynamicHeight({
	scope: '.website-topmenu',
	name: 'website-topmenu-height',
	wrappers: ['html']
});
new DynamicHeight({
	scope: '.website-header',
	name: 'website-header-height',
	wrappers: ['html']
});
